import classNames from "classnames";
import React from "react";

const inviteUser = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    className={className}
  >
    <path
      d="M6 6C7.65685 6 9 4.65685 9 3C9 1.34315 7.65685 0 6 0C4.34315 0 3 1.34315 3 3C3 4.65685 4.34315 6 6 6Z"
      fill="#4B5563"
    />
    <path
      d="M6 8C9.31371 8 12 10.6863 12 14H0C0 10.6863 2.68629 8 6 8Z"
      fill="#4B5563"
    />
    <path
      d="M14 4C14 3.44772 13.5523 3 13 3C12.4477 3 12 3.44772 12 4V5H11C10.4477 5 10 5.44771 10 6C10 6.55228 10.4477 7 11 7H12V8C12 8.55228 12.4477 9 13 9C13.5523 9 14 8.55228 14 8V7H15C15.5523 7 16 6.55228 16 6C16 5.44772 15.5523 5 15 5H14V4Z"
      fill="#4B5563"
    />
  </svg>
);

const plus = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    fill="currentColor"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    className={className || "text-gray-900"}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM9 5C9 4.44772 8.55228 4 8 4C7.44772 4 7 4.44772 7 5V7H5C4.44772 7 4 7.44771 4 8C4 8.55228 4.44772 9 5 9H7V11C7 11.5523 7.44772 12 8 12C8.55228 12 9 11.5523 9 11V9H11C11.5523 9 12 8.55228 12 8C12 7.44772 11.5523 7 11 7H9V5Z"
    />
  </svg>
);
const check = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM11.7071 6.70711C12.0976 6.31658 12.0976 5.68342 11.7071 5.29289C11.3166 4.90237 10.6834 4.90237 10.2929 5.29289L7 8.58579L5.70711 7.29289C5.31658 6.90237 4.68342 6.90237 4.29289 7.29289C3.90237 7.68342 3.90237 8.31658 4.29289 8.70711L6.29289 10.7071C6.68342 11.0976 7.31658 11.0976 7.70711 10.7071L11.7071 6.70711Z"
      fill="#34D399"
    />
  </svg>
);
const error = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25706 1.09882C7.02167 -0.26048 8.97875 -0.260481 9.74336 1.09882L15.3237 11.0194C16.0736 12.3526 15.1102 13.9999 13.5805 13.9999H2.4199C0.890251 13.9999 -0.0731769 12.3526 0.676753 11.0194L6.25706 1.09882ZM9.00012 11C9.00012 11.5523 8.55241 12 8.00012 12C7.44784 12 7.00012 11.5523 7.00012 11C7.00012 10.4477 7.44784 10 8.00012 10C8.55241 10 9.00012 10.4477 9.00012 11ZM8.00012 3C7.44784 3 7.00012 3.44772 7.00012 4V7C7.00012 7.55228 7.44784 8 8.00012 8C8.55241 8 9.00012 7.55228 9.00012 7V4C9.00012 3.44772 8.55241 3 8.00012 3Z"
      fill="#EF4444"
    />
  </svg>
);
const warning = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM9 12C9 12.5523 8.55229 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55229 11 9 11.4477 9 12ZM8 3C7.44772 3 7 3.44772 7 4V8C7 8.55228 7.44772 9 8 9C8.55229 9 9 8.55228 9 8V4C9 3.44772 8.55229 3 8 3Z"
      fill="#F59E0B"
    />
  </svg>
);
const solidCheck = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7071 5.29289C17.0976 5.68342 17.0976 6.31658 16.7071 6.70711L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071L3.29289 10.7071C2.90237 10.3166 2.90237 9.68342 3.29289 9.29289C3.68342 8.90237 4.31658 8.90237 4.70711 9.29289L8 12.5858L15.2929 5.29289C15.6834 4.90237 16.3166 4.90237 16.7071 5.29289Z"
      fill={className ? "currentColor" : "#34D399"}
    />
  </svg>
);

const accordionOpen = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7071 12.7071C14.3166 13.0976 13.6834 13.0976 13.2929 12.7071L10 9.41421L6.70711 12.7071C6.31658 13.0976 5.68342 13.0976 5.29289 12.7071C4.90237 12.3166 4.90237 11.6834 5.29289 11.2929L9.29289 7.29289C9.68342 6.90237 10.3166 6.90237 10.7071 7.29289L14.7071 11.2929C15.0976 11.6834 15.0976 12.3166 14.7071 12.7071Z"
      fill="#4B5563"
    />
  </svg>
);
const accordionClose = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.29289 7.29289C5.68342 6.90237 6.31658 6.90237 6.70711 7.29289L10 10.5858L13.2929 7.29289C13.6834 6.90237 14.3166 6.90237 14.7071 7.29289C15.0976 7.68342 15.0976 8.31658 14.7071 8.70711L10.7071 12.7071C10.3166 13.0976 9.68342 13.0976 9.29289 12.7071L5.29289 8.70711C4.90237 8.31658 4.90237 7.68342 5.29289 7.29289Z"
      fill="#374151"
    />
  </svg>
);
const step1 = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Solid/office-building">
      <path
        id="Icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 4C4 2.89543 4.89543 2 6 2H14C15.1046 2 16 2.89543 16 4V16C16.5523 16 17 16.4477 17 17C17 17.5523 16.5523 18 16 18H13C12.4477 18 12 17.5523 12 17V15C12 14.4477 11.5523 14 11 14H9C8.44772 14 8 14.4477 8 15V17C8 17.5523 7.55228 18 7 18H4C3.44772 18 3 17.5523 3 17C3 16.4477 3.44772 16 4 16V4ZM7 5H9V7H7V5ZM9 9H7V11H9V9ZM11 5H13V7H11V5ZM13 9H11V11H13V9Z"
        fill={stroke}
      />
    </g>
  </svg>
);
const step2 = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icon">
      <path
        d="M8 0C7.44772 0 7 0.447715 7 1V2C7 2.55228 7.44772 3 8 3C8.55228 3 9 2.55228 9 2V1C9 0.447715 8.55228 0 8 0Z"
        fill={stroke}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2H5C5 3.65685 6.34315 5 8 5C9.65685 5 11 3.65685 11 2H14C15.1046 2 16 2.89543 16 4V13C16 14.1046 15.1046 15 14 15H2C0.895431 15 0 14.1046 0 13V4C0 2.89543 0.895431 2 2 2ZM4.5 9C5.32843 9 6 8.32843 6 7.5C6 6.67157 5.32843 6 4.5 6C3.67157 6 3 6.67157 3 7.5C3 8.32843 3.67157 9 4.5 9ZM6.95048 13C6.98327 12.8384 7.00049 12.6712 7.00049 12.5C7.00049 11.1193 5.8812 10 4.50049 10C3.11978 10 2.00049 11.1193 2.00049 12.5C2.00049 12.6712 2.0177 12.8384 2.0505 13H6.95048ZM10 7C9.44772 7 9 7.44772 9 8C9 8.55228 9.44771 9 10 9H13C13.5523 9 14 8.55228 14 8C14 7.44772 13.5523 7 13 7H10ZM9 11C9 10.4477 9.44772 10 10 10H12C12.5523 10 13 10.4477 13 11C13 11.5523 12.5523 12 12 12H10C9.44772 12 9 11.5523 9 11Z"
        fill={stroke}
      />
    </g>
  </svg>
);
const step3 = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Solid/phone">
      <path
        id="Icon"
        d="M2 3C2 2.44772 2.44772 2 3 2H5.15287C5.64171 2 6.0589 2.35341 6.13927 2.8356L6.87858 7.27147C6.95075 7.70451 6.73206 8.13397 6.3394 8.3303L4.79126 9.10437C5.90756 11.8783 8.12168 14.0924 10.8956 15.2087L11.6697 13.6606C11.866 13.2679 12.2955 13.0492 12.7285 13.1214L17.1644 13.8607C17.6466 13.9411 18 14.3583 18 14.8471V17C18 17.5523 17.5523 18 17 18H15C7.8203 18 2 12.1797 2 5V3Z"
        fill={stroke}
      />
    </g>
  </svg>
);
const step4 = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Solid/presentation-chart-line">
      <path
        id="Icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 3C2.44772 3 2 3.44772 2 4C2 4.55228 2.44772 5 3 5V13C3 14.1046 3.89543 15 5 15H7.58579L6.29289 16.2929C5.90237 16.6834 5.90237 17.3166 6.29289 17.7071C6.68342 18.0976 7.31658 18.0976 7.70711 17.7071L10 15.4142L12.2929 17.7071C12.6834 18.0976 13.3166 18.0976 13.7071 17.7071C14.0976 17.3166 14.0976 16.6834 13.7071 16.2929L12.4142 15H15C16.1046 15 17 14.1046 17 13V5C17.5523 5 18 4.55228 18 4C18 3.44772 17.5523 3 17 3H3ZM14.7071 7.70711C15.0976 7.31658 15.0976 6.68342 14.7071 6.29289C14.3166 5.90237 13.6834 5.90237 13.2929 6.29289L10 9.58579L8.70711 8.29289C8.31658 7.90237 7.68342 7.90237 7.29289 8.29289L5.29289 10.2929C4.90237 10.6834 4.90237 11.3166 5.29289 11.7071C5.68342 12.0976 6.31658 12.0976 6.70711 11.7071L8 10.4142L9.29289 11.7071C9.68342 12.0976 10.3166 12.0976 10.7071 11.7071L14.7071 7.70711Z"
        fill={stroke}
      />
    </g>
  </svg>
);
const step5 = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Solid/shield-check">
      <path
        id="Icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.16611 4.99878C5.17437 4.95797 7.91528 3.81021 10 1.94434C12.0847 3.81021 14.8256 4.95797 17.8339 4.99878C17.9431 5.64956 18 6.31809 18 6.99991C18 12.2248 14.6608 16.6697 10 18.317C5.33923 16.6697 2 12.2248 2 6.99991C2 6.31809 2.05686 5.64956 2.16611 4.99878ZM13.7071 8.70698C14.0976 8.31646 14.0976 7.6833 13.7071 7.29277C13.3166 6.90225 12.6834 6.90225 12.2929 7.29277L9 10.5857L7.70711 9.29277C7.31658 8.90225 6.68342 8.90225 6.29289 9.29277C5.90237 9.6833 5.90237 10.3165 6.29289 10.707L8.29289 12.707C8.68342 13.0975 9.31658 13.0975 9.70711 12.707L13.7071 8.70698Z"
        fill={stroke}
      />
    </g>
  </svg>
);
const step6 = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Solid/calendar">
      <path
        id="Icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2C5.44772 2 5 2.44772 5 3V4H4C2.89543 4 2 4.89543 2 6V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V6C18 4.89543 17.1046 4 16 4H15V3C15 2.44772 14.5523 2 14 2C13.4477 2 13 2.44772 13 3V4H7V3C7 2.44772 6.55228 2 6 2ZM6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H6Z"
        fill={stroke}
      />
    </g>
  </svg>
);
const step7 = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Solid/md-library">
      <path
        id="Icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4963 2.13176C10.1889 1.95608 9.81146 1.95608 9.50403 2.13176L2.50403 6.13176C2.02451 6.40577 1.85792 7.01662 2.13193 7.49614C2.31631 7.81881 2.65322 7.99979 3 8.00017V15C2.44772 15 2 15.4477 2 16C2 16.5523 2.44772 17 3 17H17C17.5523 17 18 16.5523 18 16C18 15.4477 17.5523 15 17 15V8.00017C17.3469 7.99991 17.684 7.81892 17.8684 7.49614C18.1424 7.01662 17.9758 6.40577 17.4963 6.13176L10.4963 2.13176ZM6 9C5.44772 9 5 9.44772 5 10V13C5 13.5523 5.44772 14 6 14C6.55228 14 7 13.5523 7 13V10C7 9.44772 6.55228 9 6 9ZM9 10C9 9.44772 9.44772 9 10 9C10.5523 9 11 9.44772 11 10V13C11 13.5523 10.5523 14 10 14C9.44772 14 9 13.5523 9 13V10ZM14 9C13.4477 9 13 9.44772 13 10V13C13 13.5523 13.4477 14 14 14C14.5523 14 15 13.5523 15 13V10C15 9.44772 14.5523 9 14 9Z"
        fill={stroke}
      />
    </g>
  </svg>
);
const step8 = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Solid/truck">
      <g id="Icon">
        <path
          d="M8 16.5C8 17.3284 7.32843 18 6.5 18C5.67157 18 5 17.3284 5 16.5C5 15.6716 5.67157 15 6.5 15C7.32843 15 8 15.6716 8 16.5Z"
          fill={stroke}
        />
        <path
          d="M15 16.5C15 17.3284 14.3284 18 13.5 18C12.6716 18 12 17.3284 12 16.5C12 15.6716 12.6716 15 13.5 15C14.3284 15 15 15.6716 15 16.5Z"
          fill={stroke}
        />
        <path
          d="M3 4C2.44772 4 2 4.44772 2 5V15C2 15.5523 2.44772 16 3 16H4.05001C4.28164 14.8589 5.29052 14 6.5 14C7.70948 14 8.71836 14.8589 8.94999 16H10C10.5523 16 11 15.5523 11 15V5C11 4.44772 10.5523 4 10 4H3Z"
          fill={stroke}
        />
        <path
          d="M14 7C13.4477 7 13 7.44772 13 8V14.05C13.1616 14.0172 13.3288 14 13.5 14C14.7095 14 15.7184 14.8589 15.95 16H17C17.5523 16 18 15.5523 18 15V10C18 9.73478 17.8946 9.48043 17.7071 9.29289L15.7071 7.29289C15.5196 7.10536 15.2652 7 15 7H14Z"
          fill={stroke}
        />
      </g>
    </g>
  </svg>
);
const step9 = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Solid/bookOpen">
      <path
        id="Icon"
        d="M9 4.80423C7.9428 4.28906 6.75516 4 5.5 4C4.24484 4 3.0572 4.28906 2 4.80423V14.8042C3.0572 14.2891 4.24484 14 5.5 14C7.1686 14 8.71789 14.5108 10 15.3847C11.2821 14.5108 12.8314 14 14.5 14C15.7552 14 16.9428 14.2891 18 14.8042V4.80423C16.9428 4.28906 15.7552 4 14.5 4C13.2448 4 12.0572 4.28906 11 4.80423V12C11 12.5523 10.5523 13 10 13C9.44772 13 9 12.5523 9 12V4.80423Z"
        fill={stroke}
      />
    </g>
  </svg>
);
const step10 = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Solid/clipboard-check">
      <g id="Icon">
        <path
          d="M9 2C8.44772 2 8 2.44772 8 3C8 3.55228 8.44772 4 9 4H11C11.5523 4 12 3.55228 12 3C12 2.44772 11.5523 2 11 2H9Z"
          fill={stroke}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 5C4 3.89543 4.89543 3 6 3C6 4.65685 7.34315 6 9 6H11C12.6569 6 14 4.65685 14 3C15.1046 3 16 3.89543 16 5V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V5ZM13.7071 10.7071C14.0976 10.3166 14.0976 9.68342 13.7071 9.29289C13.3166 8.90237 12.6834 8.90237 12.2929 9.29289L9 12.5858L7.70711 11.2929C7.31658 10.9024 6.68342 10.9024 6.29289 11.2929C5.90237 11.6834 5.90237 12.3166 6.29289 12.7071L8.29289 14.7071C8.68342 15.0976 9.31658 15.0976 9.70711 14.7071L13.7071 10.7071Z"
          fill={stroke}
        />
      </g>
    </g>
  </svg>
);

const upload = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="38"
    height="42"
    viewBox="0 0 38 42"
    fill="none"
    className={className}
  >
    <path
      d="M9 29C4.58172 29 1 25.4183 1 21C1 17.1859 3.66913 13.9952 7.24141 13.1939C7.08338 12.4879 7 11.7537 7 11C7 5.47715 11.4772 1 17 1C21.8386 1 25.8746 4.4365 26.8004 9.00196C26.8668 9.00066 26.9333 9 27 9C32.5228 9 37 13.4772 37 19C37 23.8379 33.5645 27.8734 29 28.8M25 23L19 17M19 17L13 23M19 17L19 41"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const leftArrow = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7071 5.29289C13.0976 5.68342 13.0976 6.31658 12.7071 6.70711L9.41421 10L12.7071 13.2929C13.0976 13.6834 13.0976 14.3166 12.7071 14.7071C12.3166 15.0976 11.6834 15.0976 11.2929 14.7071L7.29289 10.7071C6.90237 10.3166 6.90237 9.68342 7.29289 9.29289L11.2929 5.29289C11.6834 4.90237 12.3166 4.90237 12.7071 5.29289Z"
      fill="#9CA3AF"
    />
  </svg>
);
const rightArrow = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.29289 14.7071C6.90237 14.3166 6.90237 13.6834 7.29289 13.2929L10.5858 10L7.29289 6.70711C6.90237 6.31658 6.90237 5.68342 7.29289 5.29289C7.68342 4.90237 8.31658 4.90237 8.70711 5.29289L12.7071 9.29289C13.0976 9.68342 13.0976 10.3166 12.7071 10.7071L8.70711 14.7071C8.31658 15.0976 7.68342 15.0976 7.29289 14.7071Z"
      fill="#9CA3AF"
    />
  </svg>
);
const back = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.76578 13.3656C7.45336 13.678 6.94683 13.678 6.63441 13.3656L1.83441 8.56559C1.52199 8.25317 1.52199 7.74663 1.83441 7.43422L6.63441 2.63422C6.94683 2.3218 7.45336 2.3218 7.76578 2.63422C8.0782 2.94664 8.0782 3.45317 7.76578 3.76559L4.33147 7.1999H13.6001C14.0419 7.1999 14.4001 7.55807 14.4001 7.9999C14.4001 8.44173 14.0419 8.7999 13.6001 8.7999L4.33147 8.7999L7.76578 12.2342C8.0782 12.5466 8.0782 13.0532 7.76578 13.3656Z"
      fill={className ? "currentColor" : "#1F2937"}
    />
  </svg>
);

const redDelete = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_1038_11919)">
      <rect x="2" y="1" width="34" height="34" rx="17" fill="#FEE2E2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 10C17.6212 10 17.275 10.214 17.1056 10.5528L16.382 12H13C12.4477 12 12 12.4477 12 13C12 13.5523 12.4477 14 13 14L13 24C13 25.1046 13.8954 26 15 26H23C24.1046 26 25 25.1046 25 24V14C25.5523 14 26 13.5523 26 13C26 12.4477 25.5523 12 25 12H21.618L20.8944 10.5528C20.725 10.214 20.3788 10 20 10H18ZM16 16C16 15.4477 16.4477 15 17 15C17.5523 15 18 15.4477 18 16V22C18 22.5523 17.5523 23 17 23C16.4477 23 16 22.5523 16 22V16ZM21 15C20.4477 15 20 15.4477 20 16V22C20 22.5523 20.4477 23 21 23C21.5523 23 22 22.5523 22 22V16C22 15.4477 21.5523 15 21 15Z"
        fill="#7F1D1D"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1038_11919"
        x="0"
        y="0"
        width="38"
        height="38"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1038_11919"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1038_11919"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
const disabledDelete = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.3" filter="url(#filter0_d_1848_1384)">
      <rect x="2" y="1" width="34" height="34" rx="17" fill="#FEE2E2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 10C17.6212 10 17.275 10.214 17.1056 10.5528L16.382 12H13C12.4477 12 12 12.4477 12 13C12 13.5523 12.4477 14 13 14L13 24C13 25.1046 13.8954 26 15 26H23C24.1046 26 25 25.1046 25 24V14C25.5523 14 26 13.5523 26 13C26 12.4477 25.5523 12 25 12H21.618L20.8944 10.5528C20.725 10.214 20.3788 10 20 10H18ZM16 16C16 15.4477 16.4477 15 17 15C17.5523 15 18 15.4477 18 16V22C18 22.5523 17.5523 23 17 23C16.4477 23 16 22.5523 16 22V16ZM21 15C20.4477 15 20 15.4477 20 16V22C20 22.5523 20.4477 23 21 23C21.5523 23 22 22.5523 22 22V16C22 15.4477 21.5523 15 21 15Z"
        fill="#7F1D1D"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1848_1384"
        x="0"
        y="0"
        width="38"
        height="38"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1848_1384"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1848_1384"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
const deleteIcon = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 2C8.62123 2 8.27497 2.214 8.10557 2.55279L7.38197 4H4C3.44772 4 3 4.44772 3 5C3 5.55228 3.44772 6 4 6L4 16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16V6C16.5523 6 17 5.55228 17 5C17 4.44772 16.5523 4 16 4H12.618L11.8944 2.55279C11.725 2.214 11.3788 2 11 2H9ZM7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8V14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14V8ZM12 7C11.4477 7 11 7.44772 11 8V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V8C13 7.44772 12.5523 7 12 7Z"
      fill={className ? "currentColor" : "#111827"}
    />
  </svg>
);

const document = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.7998 4.7999C4.7998 3.47442 5.87432 2.3999 7.1998 2.3999H12.7027C13.3393 2.3999 13.9497 2.65276 14.3998 3.10285L18.4969 7.1999C18.9469 7.64999 19.1998 8.26044 19.1998 8.89696V19.1999C19.1998 20.5254 18.1253 21.5999 16.7998 21.5999H7.1998C5.87432 21.5999 4.7998 20.5254 4.7998 19.1999V4.7999ZM7.1998 11.9999C7.1998 11.3372 7.73706 10.7999 8.3998 10.7999H15.5998C16.2625 10.7999 16.7998 11.3372 16.7998 11.9999C16.7998 12.6626 16.2625 13.1999 15.5998 13.1999H8.3998C7.73706 13.1999 7.1998 12.6626 7.1998 11.9999ZM8.3998 15.5999C7.73706 15.5999 7.1998 16.1372 7.1998 16.7999C7.1998 17.4626 7.73706 17.9999 8.3998 17.9999H15.5998C16.2625 17.9999 16.7998 17.4626 16.7998 16.7999C16.7998 16.1372 16.2625 15.5999 15.5998 15.5999H8.3998Z"
      fill={className ? "currentColor" : "#2AC0E6"}
    />
  </svg>
);

const exclamation = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.25706 3.09882C9.02167 1.73952 10.9788 1.73952 11.7434 3.09882L17.3237 13.0194C18.0736 14.3526 17.1102 15.9999 15.5805 15.9999H4.4199C2.89025 15.9999 1.92682 14.3526 2.67675 13.0194L8.25706 3.09882ZM11.0001 13C11.0001 13.5523 10.5524 14 10.0001 14C9.44784 14 9.00012 13.5523 9.00012 13C9.00012 12.4477 9.44784 12 10.0001 12C10.5524 12 11.0001 12.4477 11.0001 13ZM10.0001 5C9.44784 5 9.00012 5.44772 9.00012 6V9C9.00012 9.55228 9.44784 10 10.0001 10C10.5524 10 11.0001 9.55228 11.0001 9V6C11.0001 5.44772 10.5524 5 10.0001 5Z"
      fill="currentColor"
    />
  </svg>
);

const pencil = (
  stroke: string,
  className: string,
  size: number,
  height: number,
  width: number
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      d="M10.869 2.86853C11.4939 2.24369 12.5069 2.24369 13.1318 2.86853C13.7566 3.49337 13.7566 4.50643 13.1318 5.13127L12.4974 5.76559L10.2347 3.50285L10.869 2.86853Z"
      fill={className ? "currentColor" : "#111827"}
    />
    <path
      d="M9.10334 4.63422L2.40039 11.3372V13.5999H4.66313L11.3661 6.89696L9.10334 4.63422Z"
      fill={className ? "currentColor" : "#111827"}
    />
  </svg>
);

const info = (
  stroke: string,
  className: string,
  size = 8,
  height = 16,
  width = 16
) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM9 4C9 4.55228 8.55228 5 8 5C7.44772 5 7 4.55228 7 4C7 3.44772 7.44772 3 8 3C8.55228 3 9 3.44772 9 4ZM7 7C6.44772 7 6 7.44772 6 8C6 8.55229 6.44772 9 7 9V12C7 12.5523 7.44772 13 8 13H9C9.55228 13 10 12.5523 10 12C10 11.4477 9.55228 11 9 11V8C9 7.44772 8.55228 7 8 7H7Z"
      fill={className ? "currentColor" : "#0FACD7"}
    />
  </svg>
);

const downChevron = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.23431 5.83441C4.54673 5.52199 5.05327 5.52199 5.36569 5.83441L8 8.46873L10.6343 5.83441C10.9467 5.52199 11.4533 5.52199 11.7657 5.83441C12.0781 6.14683 12.0781 6.65336 11.7657 6.96578L8.56569 10.1658C8.25327 10.4782 7.74673 10.4782 7.43431 10.1658L4.23431 6.96578C3.9219 6.65336 3.9219 6.14683 4.23431 5.83441Z"
      fill={className ? "currentColor" : "#13698B"}
    />
  </svg>
);
const calendar = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 0C3.44772 0 3 0.447715 3 1V2H2C0.895431 2 0 2.89543 0 4V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V4C16 2.89543 15.1046 2 14 2H13V1C13 0.447715 12.5523 0 12 0C11.4477 0 11 0.447715 11 1V2H5V1C5 0.447715 4.55228 0 4 0ZM4 5C3.44772 5 3 5.44772 3 6C3 6.55228 3.44772 7 4 7H12C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5H4Z"
      fill={className ? "currentColor" : "#6B7280"}
    />
  </svg>
);
const calendarOutline = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2931_17304)">
      <path
        d="M9.33333 1.16663V3.49996M4.66667 1.16663V3.49996M1.75 5.83329H12.25M2.91667 2.33329H11.0833C11.7277 2.33329 12.25 2.85563 12.25 3.49996V11.6666C12.25 12.311 11.7277 12.8333 11.0833 12.8333H2.91667C2.27233 12.8333 1.75 12.311 1.75 11.6666V3.49996C1.75 2.85563 2.27233 2.33329 2.91667 2.33329Z"
        stroke="#6B7280"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2931_17304">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const clock = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM9 4C9 3.44772 8.55229 3 8 3C7.44772 3 7 3.44772 7 4V8C7 8.26522 7.10536 8.51957 7.29289 8.70711L10.1213 11.5355C10.5118 11.9261 11.145 11.9261 11.5355 11.5355C11.9261 11.145 11.9261 10.5118 11.5355 10.1213L9 7.58579V4Z"
      fill="#9CA3AF"
    />
  </svg>
);

const search = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2C3.79086 2 2 3.79086 2 6C2 8.20914 3.79086 10 6 10C8.20914 10 10 8.20914 10 6C10 3.79086 8.20914 2 6 2ZM0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 7.29583 11.5892 8.49572 10.8907 9.47653L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L9.47653 10.8907C8.49572 11.5892 7.29583 12 6 12C2.68629 12 0 9.31371 0 6Z"
      fill={className ? "currentColor" : "#9CA3AF"}
    />
  </svg>
);
const invited = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.35198 5.12992C1.88417 5.4223 1.59998 5.93506 1.59998 6.48672V12.7999C1.59998 13.6836 2.31632 14.3999 3.19998 14.3999H12.8C13.6836 14.3999 14.4 13.6836 14.4 12.7999V6.48672C14.4 5.93505 14.1158 5.4223 13.648 5.12992L8.84797 2.12992C8.32914 1.80565 7.67081 1.80565 7.15198 2.12992L2.35198 5.12992ZM4.44374 7.06769C4.07611 6.82261 3.57942 6.92195 3.33434 7.28957C3.08925 7.6572 3.18859 8.15389 3.55622 8.39897L7.55621 11.0656C7.82493 11.2448 8.17502 11.2448 8.44374 11.0656L12.4437 8.39897C12.8114 8.15389 12.9107 7.6572 12.6656 7.28957C12.4205 6.92195 11.9238 6.82261 11.5562 7.06769L7.99998 9.43852L4.44374 7.06769Z"
      fill="#DB2777"
    />
  </svg>
);
const logo = (
  stroke: string,
  className: string,
  size = 16,
  height = 26,
  width = 120
) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 120 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2009_8119)">
      <path
        d="M0.970944 2.80784C0.970944 2.44384 1.09228 2.3225 1.45628 2.3225H15.5311C15.7738 2.3225 15.8951 2.44384 15.8951 2.80784V4.99187C15.8951 5.35587 15.7738 5.59854 15.4098 5.59854H5.703C5.33899 5.59854 5.21766 5.71987 5.21766 5.96254V11.0586C5.21766 11.3013 5.33899 11.5439 5.58166 11.5439H12.2551C12.4977 11.5439 12.7404 11.6653 12.7404 12.0293V14.2133C12.7404 14.456 12.6191 14.5773 12.3764 14.5773H5.703C5.46033 14.5773 5.33899 14.6986 5.33899 14.9413V20.4014C5.33899 20.5227 5.33899 20.644 5.33899 20.644C5.33899 20.644 5.46033 20.644 5.58166 20.644H15.7738C15.8951 20.644 16.0164 20.644 16.1378 20.7654C16.2591 20.7654 16.2591 20.8867 16.2591 21.1294V23.4347C16.2591 23.5561 16.2591 23.6774 16.1378 23.7987C16.0164 23.9201 15.8951 23.9201 15.7738 23.9201H1.45628C1.21361 23.9201 1.09228 23.9201 0.970944 23.7987C0.849609 23.6774 0.849609 23.5561 0.849609 23.4347V2.80784H0.970944ZM26.6939 2.3225C26.9366 2.3225 27.0579 2.44384 27.0579 2.80784V23.3134C27.0579 23.5561 27.0579 23.6774 26.9366 23.7987C26.8152 23.9201 26.6939 23.9201 26.4512 23.9201H23.4179C23.1752 23.9201 23.0539 23.9201 22.9325 23.7987C22.8112 23.6774 22.8112 23.5561 22.8112 23.4347V2.80784C22.8112 2.44384 22.9325 2.3225 23.2965 2.3225H26.6939ZM43.4381 2.07983C44.8941 2.07983 46.1074 2.3225 47.3208 2.92918C48.5341 3.41452 49.5048 4.26386 50.3542 5.1132C51.2035 6.08388 51.6888 7.17589 51.8102 8.2679C51.8102 8.38924 51.8102 8.51057 51.8102 8.63191C51.8102 8.75324 51.8102 8.87458 51.6888 8.87458C51.6888 8.87458 51.5675 8.99591 51.4462 8.99591L48.1701 9.23858C48.0488 9.23858 47.9275 9.23858 47.9275 9.23858C47.9275 9.23858 47.8061 9.11725 47.8061 8.87458C47.5635 7.78256 47.0781 6.81189 46.3501 6.20521C45.6221 5.47721 44.6514 5.23454 43.5594 5.23454C40.0407 5.23454 38.342 7.9039 38.342 13.2426C38.342 15.912 38.8274 17.9747 39.6767 19.188C40.5261 20.5227 41.8607 21.1294 43.6808 21.1294C44.8941 21.1294 45.9861 20.8867 46.8355 20.28C47.6848 19.6734 48.4128 18.7027 48.8981 17.368C48.8981 17.2467 49.1408 17.1253 49.3835 17.2467L51.8102 17.732C51.9315 17.732 51.9315 17.8533 52.0528 17.9747C52.0528 18.096 52.1742 18.2173 52.0528 18.46C51.8102 19.3094 51.3248 20.28 50.5968 21.1294C49.8688 22.1001 48.8981 22.8281 47.6848 23.5561C46.4714 24.2841 45.0154 24.5268 43.3167 24.5268C41.3754 24.5268 39.6767 24.0414 38.2207 23.1921C36.7647 22.2214 35.6727 21.008 34.8233 19.3094C34.0953 17.6107 33.61 15.6693 33.61 13.364C33.61 11.0586 33.974 9.11725 34.8233 7.53989C35.6727 5.96254 36.7647 4.62786 38.0994 3.77852C39.798 2.44384 41.4967 2.07983 43.4381 2.07983ZM56.2996 23.9201C56.0569 23.9201 55.9356 23.7987 55.9356 23.5561C55.9356 23.5561 55.9356 23.4347 55.9356 23.1921L63.2156 2.80784C63.337 2.56517 63.337 2.44384 63.4583 2.44384C63.5796 2.3225 63.701 2.3225 63.9436 2.3225H67.5837C68.069 2.3225 68.3117 2.56517 68.433 2.92918L75.7131 23.3134C75.7131 23.4347 75.7131 23.5561 75.7131 23.5561C75.7131 23.6774 75.7131 23.7987 75.5918 23.9201C75.5918 24.0414 75.4704 24.0414 75.3491 24.0414H71.8304C71.5877 24.0414 71.3451 23.9201 71.3451 23.6774L69.6464 18.9454C69.6464 18.824 69.525 18.824 69.525 18.7027C69.525 18.7027 69.4037 18.5814 69.2824 18.5814H61.6383C61.5169 18.5814 61.3956 18.7027 61.2743 18.824L59.5756 23.5561C59.5756 23.7987 59.3329 23.9201 59.0903 23.9201H56.2996ZM68.3117 15.184C68.433 15.184 68.5544 15.0626 68.5544 14.9413C68.5544 14.82 68.5544 14.82 68.5544 14.6986L65.7637 6.93322C65.7637 6.81189 65.6423 6.69055 65.521 6.69055C65.3997 6.69055 65.3997 6.81189 65.2783 6.93322L62.4876 14.6986C62.4876 14.82 62.4876 14.9413 62.4876 14.9413C62.4876 15.0626 62.609 15.184 62.7303 15.184H68.3117ZM98.2814 23.1921C98.2814 23.1921 98.2814 23.3134 98.2814 23.4347C98.2814 23.5561 98.2814 23.6774 98.16 23.7987C98.16 23.9201 98.0387 23.9201 97.9174 23.9201H94.3987C94.2773 23.9201 94.156 23.9201 94.0347 23.7987C93.9133 23.6774 93.9133 23.5561 93.792 23.4347L90.3946 14.9413C90.3946 14.82 90.2733 14.6986 90.1519 14.6986C90.0306 14.6986 89.9093 14.5773 89.6666 14.5773H86.1479C85.9052 14.5773 85.7839 14.6986 85.7839 14.9413V23.3134C85.7839 23.5561 85.7839 23.6774 85.6626 23.7987C85.5412 23.9201 85.4199 23.9201 85.1772 23.9201H82.1438C81.9012 23.9201 81.7799 23.9201 81.6585 23.7987C81.5372 23.6774 81.5372 23.5561 81.5372 23.4347V2.80784C81.5372 2.44384 81.6585 2.3225 82.0225 2.3225H90.7586C93.3066 2.3225 95.248 2.80784 96.5827 3.77852C97.9174 4.7492 98.6454 6.20521 98.6454 8.14657C98.6454 9.60258 98.2814 10.8159 97.432 11.7866C96.704 12.7573 95.7333 13.4853 94.52 13.8493C94.3987 13.8493 94.2773 14.092 94.3987 14.2133L98.2814 23.1921ZM90.1519 11.5439C92.8213 11.5439 94.156 10.4519 94.156 8.38924C94.156 7.29722 93.792 6.56922 93.1853 5.96254C92.5786 5.4772 91.608 5.1132 90.5159 5.1132H86.3906C86.1479 5.1132 86.0266 5.1132 86.0266 5.23454C85.9052 5.23454 85.9052 5.35587 85.9052 5.59854V11.0586C85.9052 11.1799 85.9052 11.3013 86.0266 11.4226C86.0266 11.4226 86.1479 11.5439 86.2692 11.5439H90.1519ZM104.591 2.80784C104.591 2.44384 104.712 2.3225 105.076 2.3225H119.151C119.394 2.3225 119.515 2.44384 119.515 2.80784V4.99187C119.515 5.35587 119.394 5.59854 119.03 5.59854H109.444C109.08 5.59854 108.959 5.71987 108.959 5.96254V11.0586C108.959 11.3013 109.08 11.5439 109.323 11.5439H115.996C116.239 11.5439 116.482 11.6653 116.482 12.0293V14.2133C116.482 14.456 116.36 14.5773 116.118 14.5773H109.444C109.201 14.5773 109.08 14.6986 109.08 14.9413V20.4014C109.08 20.5227 109.08 20.644 109.08 20.644C109.08 20.644 109.201 20.644 109.323 20.644H119.515C119.636 20.644 119.758 20.644 119.879 20.7654C120 20.7654 120 20.8867 120 21.1294V23.4347C120 23.5561 120 23.6774 119.879 23.7987C119.758 23.9201 119.636 23.9201 119.394 23.9201H105.197C104.955 23.9201 104.833 23.9201 104.712 23.7987C104.591 23.6774 104.591 23.5561 104.591 23.4347V2.80784Z"
        fill={className ? "currentColor" : "#37C3E9"}
      />
    </g>
    <defs>
      <clipPath id="clip0_2009_8119">
        <rect
          width={width}
          height={height}
          fill="white"
          transform="translate(0 0.866455)"
        />
      </clipPath>
    </defs>
  </svg>
);
const download = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 15C-2.41411e-08 14.4477 0.447715 14 1 14H13C13.5523 14 14 14.4477 14 15C14 15.5523 13.5523 16 13 16H1C0.447715 16 2.41411e-08 15.5523 0 15ZM3.29289 7.29289C3.68342 6.90237 4.31658 6.90237 4.70711 7.29289L6 8.58579L6 1C6 0.447716 6.44771 2.41411e-08 7 0C7.55228 -2.41411e-08 8 0.447715 8 1L8 8.58579L9.29289 7.29289C9.68342 6.90237 10.3166 6.90237 10.7071 7.29289C11.0976 7.68342 11.0976 8.31658 10.7071 8.70711L7.70711 11.7071C7.51957 11.8946 7.26522 12 7 12C6.73478 12 6.48043 11.8946 6.29289 11.7071L3.29289 8.70711C2.90237 8.31658 2.90237 7.68342 3.29289 7.29289Z"
      fill="#111827"
    />
  </svg>
);
const inProgress = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.79998 8.00002C4.79998 8.88368 4.08363 9.60002 3.19998 9.60002C2.31632 9.60002 1.59998 8.88368 1.59998 8.00002C1.59998 7.11637 2.31632 6.40002 3.19998 6.40002C4.08363 6.40002 4.79998 7.11637 4.79998 8.00002Z"
      fill="#2563EB"
    />
    <path
      d="M9.59998 8.00002C9.59998 8.88368 8.88363 9.60002 7.99998 9.60002C7.11632 9.60002 6.39998 8.88368 6.39998 8.00002C6.39998 7.11637 7.11632 6.40002 7.99998 6.40002C8.88363 6.40002 9.59998 7.11637 9.59998 8.00002Z"
      fill="#2563EB"
    />
    <path
      d="M12.8 9.60002C13.6836 9.60002 14.4 8.88368 14.4 8.00002C14.4 7.11637 13.6836 6.40002 12.8 6.40002C11.9163 6.40002 11.2 7.11637 11.2 8.00002C11.2 8.88368 11.9163 9.60002 12.8 9.60002Z"
      fill="#2563EB"
    />
  </svg>
);
const hazardWarning = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="14"
    height="12"
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.60552 1.47903C6.21721 0.391592 7.78288 0.391591 8.39457 1.47903L12.8588 9.41547C13.4588 10.482 12.688 11.7999 11.4643 11.7999H2.5358C1.31208 11.7999 0.541336 10.482 1.14128 9.41547L5.60552 1.47903ZM7.79998 9.39997C7.79998 9.8418 7.4418 10.2 6.99998 10.2C6.55815 10.2 6.19998 9.8418 6.19998 9.39997C6.19998 8.95815 6.55815 8.59998 6.99998 8.59998C7.4418 8.59998 7.79998 8.95815 7.79998 9.39997ZM6.99998 2.99998C6.55815 2.99998 6.19998 3.35815 6.19998 3.79998V6.19998C6.19998 6.6418 6.55815 6.99998 6.99998 6.99998C7.4418 6.99998 7.79998 6.6418 7.79998 6.19998V3.79998C7.79998 3.35815 7.4418 2.99998 6.99998 2.99998Z"
      fill="#D97706"
    />
  </svg>
);
const recycle = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 0C1.55228 0 2 0.447715 2 1V3.10125C3.27009 1.80489 5.04052 1 7 1C10.0494 1 12.641 2.94932 13.6014 5.66675C13.7855 6.18747 13.5126 6.75879 12.9918 6.94284C12.4711 7.12689 11.8998 6.85396 11.7157 6.33325C11.0289 4.38991 9.17547 3 7 3C5.36507 3 3.91204 3.78502 2.99935 5H6C6.55228 5 7 5.44772 7 6C7 6.55228 6.55228 7 6 7H1C0.447715 7 0 6.55228 0 6V1C0 0.447715 0.447715 0 1 0ZM1.00817 9.05716C1.52888 8.87311 2.1002 9.14604 2.28425 9.66675C2.97112 11.6101 4.82453 13 7 13C8.63493 13 10.088 12.215 11.0006 11L8 11C7.44772 11 7 10.5523 7 10C7 9.44771 7.44772 9 8 9H13C13.2652 9 13.5196 9.10536 13.7071 9.29289C13.8946 9.48043 14 9.73478 14 10V15C14 15.5523 13.5523 16 13 16C12.4477 16 12 15.5523 12 15V12.8987C10.7299 14.1951 8.95948 15 7 15C3.95059 15 1.35905 13.0507 0.398572 10.3332C0.214525 9.81253 0.487449 9.24121 1.00817 9.05716Z"
      fill="currentColor"
    />
  </svg>
);
const assistance = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.6 12C21.6 17.3019 17.3019 21.6 12 21.6C6.69806 21.6 2.39999 17.3019 2.39999 12C2.39999 6.69806 6.69806 2.39999 12 2.39999C17.3019 2.39999 21.6 6.69806 21.6 12ZM12 8.39999C11.5574 8.39999 11.1691 8.63905 10.9598 9.00086C10.628 9.57454 9.89389 9.77057 9.32022 9.43872C8.74654 9.10687 8.55051 8.3728 8.88236 7.79912C9.50301 6.72621 10.666 5.99999 12 5.99999C13.9882 5.99999 15.6 7.61177 15.6 9.59999C15.6 11.1675 14.5982 12.5009 13.2 12.9951V13.2C13.2 13.8627 12.6628 14.4 12 14.4C11.3373 14.4 10.8 13.8627 10.8 13.2V12C10.8 11.3373 11.3373 10.8 12 10.8C12.6628 10.8 13.2 10.2627 13.2 9.59999C13.2 8.93725 12.6628 8.39999 12 8.39999ZM12 18C12.6627 18 13.2 17.4627 13.2 16.8C13.2 16.1373 12.6627 15.6 12 15.6C11.3373 15.6 10.8 16.1373 10.8 16.8C10.8 17.4627 11.3373 18 12 18Z"
      fill="#374151"
    />
  </svg>
);
const email = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.404 7.06027L11.9999 11.8582L21.596 7.06021C21.5236 5.79979 20.4786 4.8 19.2 4.8H4.8C3.52142 4.8 2.47636 5.79982 2.404 7.06027Z"
      fill="#9CA3AF"
    />
    <path
      d="M21.6 9.74149L11.9999 14.5415L2.4 9.74155V16.8C2.4 18.1255 3.47452 19.2 4.8 19.2H19.2C20.5255 19.2 21.6 18.1255 21.6 16.8V9.74149Z"
      fill="#9CA3AF"
    />
  </svg>
);
const phone = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.4 3.59999C2.4 2.93725 2.93726 2.39999 3.6 2.39999H6.18345C6.77006 2.39999 7.27068 2.82409 7.36712 3.40272L8.2543 8.72576C8.3409 9.2454 8.07847 9.76076 7.60728 9.99636L5.74951 10.9252C7.08907 14.254 9.74602 16.9109 13.0748 18.2505L14.0036 16.3927C14.2392 15.9215 14.7546 15.6591 15.2742 15.7457L20.5973 16.6329C21.1759 16.7293 21.6 17.2299 21.6 17.8165V20.4C21.6 21.0627 21.0627 21.6 20.4 21.6H18C9.38436 21.6 2.4 14.6156 2.4 5.99999V3.59999Z"
      fill="#9CA3AF"
    />
  </svg>
);
const solidCross = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75 16C13.1683 16 16.75 12.4183 16.75 8C16.75 3.58172 13.1683 0 8.75 0C4.33172 0 0.75 3.58172 0.75 8C0.75 12.4183 4.33172 16 8.75 16ZM7.45711 5.29289C7.06658 4.90237 6.43342 4.90237 6.04289 5.29289C5.65237 5.68342 5.65237 6.31658 6.04289 6.70711L7.33579 8L6.04289 9.29289C5.65237 9.68342 5.65237 10.3166 6.04289 10.7071C6.43342 11.0976 7.06658 11.0976 7.45711 10.7071L8.75 9.41421L10.0429 10.7071C10.4334 11.0976 11.0666 11.0976 11.4571 10.7071C11.8476 10.3166 11.8476 9.68342 11.4571 9.29289L10.1642 8L11.4571 6.70711C11.8476 6.31658 11.8476 5.68342 11.4571 5.29289C11.0666 4.90237 10.4334 4.90237 10.0429 5.29289L8.75 6.58579L7.45711 5.29289Z"
      fill="#4B5563"
    />
  </svg>
);
const coloredCheck = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.75 16C13.1683 16 16.75 12.4183 16.75 8C16.75 3.58172 13.1683 0 8.75 0C4.33172 0 0.75 3.58172 0.75 8C0.75 12.4183 4.33172 16 8.75 16ZM12.4571 6.70711C12.8476 6.31658 12.8476 5.68342 12.4571 5.29289C12.0666 4.90237 11.4334 4.90237 11.0429 5.29289L7.75 8.58579L6.45711 7.29289C6.06658 6.90237 5.43342 6.90237 5.04289 7.29289C4.65237 7.68342 4.65237 8.31658 5.04289 8.70711L7.04289 10.7071C7.43342 11.0976 8.06658 11.0976 8.45711 10.7071L12.4571 6.70711Z"
      fill="white"
    />
  </svg>
);
const rightDirectionArrow = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.7929 5.29289C11.1834 4.90237 11.8166 4.90237 12.2071 5.29289L16.2071 9.29289C16.5976 9.68342 16.5976 10.3166 16.2071 10.7071L12.2071 14.7071C11.8166 15.0976 11.1834 15.0976 10.7929 14.7071C10.4024 14.3166 10.4024 13.6834 10.7929 13.2929L13.0858 11L5.5 11C4.94772 11 4.5 10.5523 4.5 10C4.5 9.44772 4.94772 9 5.5 9H13.0858L10.7929 6.70711C10.4024 6.31658 10.4024 5.68342 10.7929 5.29289Z"
      fill="#111827"
    />
  </svg>
);

const user = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <g clipPath="url(#clip0_2931_17300)">
      <rect width="24" height="24" rx="12" fill={stroke ? stroke : "#D1F5FC"} />
      <path
        d="M24 20.994V24.001H0V21.005C1.39595 19.1395 3.20791 17.6253 5.29179 16.5831C7.37567 15.5408 9.67399 14.9991 12.004 15.001C16.908 15.001 21.264 17.355 24 20.994ZM16.002 9C16.002 10.0609 15.5806 11.0783 14.8304 11.8284C14.0803 12.5786 13.0629 13 12.002 13C10.9411 13 9.92372 12.5786 9.17357 11.8284C8.42343 11.0783 8.002 10.0609 8.002 9C8.002 7.93913 8.42343 6.92172 9.17357 6.17157C9.92372 5.42143 10.9411 5 12.002 5C13.0629 5 14.0803 5.42143 14.8304 6.17157C15.5806 6.92172 16.002 7.93913 16.002 9Z"
        fill={className ? "currentColor" : "#2AC0E6"}
      />
    </g>
    <defs>
      <clipPath id="clip0_2931_17300">
        <rect width="24" height="24" rx="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const userGrayAndWhite = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM10 5C10 6.10457 9.10457 7 8 7C6.89543 7 6 6.10457 6 5C6 3.89543 6.89543 3 8 3C9.10457 3 10 3.89543 10 5ZM7.99993 9C5.98239 9 4.24394 10.195 3.45374 11.9157C4.55403 13.192 6.18265 14 7.99998 14C9.81728 14 11.4459 13.1921 12.5462 11.9158C11.756 10.195 10.0175 9 7.99993 9Z"
      fill="#9CA3AF"
    />
  </svg>
);

const comment = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 13V5C18 3.89543 17.1046 3 16 3H4C2.89543 3 2 3.89543 2 5V13C2 14.1046 2.89543 15 4 15H7L10 18L13 15H16C17.1046 15 18 14.1046 18 13ZM5 7C5 6.44772 5.44772 6 6 6H14C14.5523 6 15 6.44772 15 7C15 7.55228 14.5523 8 14 8H6C5.44772 8 5 7.55228 5 7ZM6 10C5.44772 10 5 10.4477 5 11C5 11.5523 5.44772 12 6 12H9C9.55229 12 10 11.5523 10 11C10 10.4477 9.55229 10 9 10H6Z"
      fill="#0FACD7"
    />
  </svg>
);
const close = (
  stroke: string,
  className: string,
  size = 20,
  height: number,
  width: number
) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L10 8.58579L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L11.4142 10L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L10 11.4142L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L8.58579 10L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z"
      fill="currentColor"
    />
  </svg>
);
const logout = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 21"
    fill="none"
    className={className}
  >
    <path
      d="M3 3.75586C2.44772 3.75586 2 4.20358 2 4.75586V16.7559C2 17.3081 2.44772 17.7559 3 17.7559C3.55228 17.7559 4 17.3081 4 16.7559V4.75586C4 4.20357 3.55228 3.75586 3 3.75586Z"
      fill={className ? "currentColor" : "#4B5563"}
    />
    <path
      d="M13.2929 13.0488C12.9024 13.4393 12.9024 14.0724 13.2929 14.463C13.6834 14.8535 14.3166 14.8535 14.7071 14.463L17.7071 11.463C17.8946 11.2754 18 11.0211 18 10.7559C18 10.4906 17.8946 10.2363 17.7071 10.0488L14.7071 7.04875C14.3166 6.65823 13.6834 6.65823 13.2929 7.04875C12.9024 7.43928 12.9024 8.07244 13.2929 8.46297L14.5858 9.75586L7 9.75586C6.44771 9.75586 6 10.2036 6 10.7559C6 11.3081 6.44772 11.7559 7 11.7559H14.5858L13.2929 13.0488Z"
      fill={className ? "currentColor" : "#4B5563"}
    />
  </svg>
);
const filter = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 3C3 2.44772 3.44772 2 4 2H16C16.5523 2 17 2.44772 17 3V6C17 6.26522 16.8946 6.51957 16.7071 6.70711L12 11.4142V15C12 15.2652 11.8946 15.5196 11.7071 15.7071L9.70711 17.7071C9.42111 17.9931 8.99099 18.0787 8.61732 17.9239C8.24364 17.7691 8 17.4045 8 17V11.4142L3.29289 6.70711C3.10536 6.51957 3 6.26522 3 6V3Z"
      fill="#374151"
    />
  </svg>
);
const settings = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.48922 1.17094C9.1102 -0.390314 6.8898 -0.390314 6.51078 1.17094C6.26594 2.17949 5.11045 2.65811 4.22416 2.11809C2.85218 1.28212 1.28212 2.85218 2.11809 4.22416C2.65811 5.11045 2.17949 6.26593 1.17094 6.51078C-0.390314 6.8898 -0.390314 9.1102 1.17094 9.48922C2.17949 9.73407 2.65811 10.8896 2.11809 11.7758C1.28212 13.1478 2.85218 14.7179 4.22417 13.8819C5.11045 13.3419 6.26594 13.8205 6.51078 14.8291C6.8898 16.3903 9.1102 16.3903 9.48922 14.8291C9.73407 13.8205 10.8896 13.3419 11.7758 13.8819C13.1478 14.7179 14.7179 13.1478 13.8819 11.7758C13.3419 10.8896 13.8205 9.73407 14.8291 9.48922C16.3903 9.1102 16.3903 6.8898 14.8291 6.51078C13.8205 6.26593 13.3419 5.11045 13.8819 4.22416C14.7179 2.85218 13.1478 1.28212 11.7758 2.11809C10.8896 2.65811 9.73407 2.17949 9.48922 1.17094ZM8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C6.34315 5 5 6.34315 5 8C5 9.65685 6.34315 11 8 11Z"
      fill="#9CA3AF"
    />
  </svg>
);
const bell = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2.40002C8.02356 2.40002 4.80001 5.62357 4.80001 9.60002V13.903L3.95148 14.7515C3.60828 15.0947 3.50562 15.6108 3.69136 16.0592C3.87709 16.5077 4.31466 16.8 4.80001 16.8H19.2C19.6854 16.8 20.1229 16.5077 20.3087 16.0592C20.4944 15.6108 20.3917 15.0947 20.0485 14.7515L19.2 13.903V9.60002C19.2 5.62357 15.9765 2.40002 12 2.40002Z"
      fill="#374151"
    />
    <path
      d="M12 21.6C10.0118 21.6 8.39998 19.9883 8.39998 18H15.6C15.6 19.9883 13.9882 21.6 12 21.6Z"
      fill="#374151"
    />
  </svg>
);
const groups = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg className={className} viewBox="0 0 20 20" fill="currentColor">
    <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
  </svg>
);
const addNewStaff = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M8 9C9.65685 9 11 7.65685 11 6C11 4.34315 9.65685 3 8 3C6.34315 3 5 4.34315 5 6C5 7.65685 6.34315 9 8 9Z"
      fill={className ? "currentColor" : "#4B5563"}
    />
    <path
      d="M8 11C11.3137 11 14 13.6863 14 17H2C2 13.6863 4.68629 11 8 11Z"
      fill={className ? "currentColor" : "#4B5563"}
    />
    <path
      d="M16 7C16 6.44772 15.5523 6 15 6C14.4477 6 14 6.44772 14 7V8H13C12.4477 8 12 8.44771 12 9C12 9.55228 12.4477 10 13 10H14V11C14 11.5523 14.4477 12 15 12C15.5523 12 16 11.5523 16 11V10H17C17.5523 10 18 9.55228 18 9C18 8.44772 17.5523 8 17 8H16V7Z"
      fill={className ? "currentColor" : "#4B5563"}
    />
    <path
      d="M8 9C9.65685 9 11 7.65685 11 6C11 4.34315 9.65685 3 8 3C6.34315 3 5 4.34315 5 6C5 7.65685 6.34315 9 8 9Z"
      stroke={className ? "currentColor" : "#4B5563"}
    />
    <path
      d="M8 11C11.3137 11 14 13.6863 14 17H2C2 13.6863 4.68629 11 8 11Z"
      stroke={className ? "currentColor" : "#4B5563"}
    />
    <path
      d="M16 7C16 6.44772 15.5523 6 15 6C14.4477 6 14 6.44772 14 7V8H13C12.4477 8 12 8.44771 12 9C12 9.55228 12.4477 10 13 10H14V11C14 11.5523 14.4477 12 15 12C15.5523 12 16 11.5523 16 11V10H17C17.5523 10 18 9.55228 18 9C18 8.44772 17.5523 8 17 8H16V7Z"
      stroke={className ? "currentColor" : "#4B5563"}
    />
  </svg>
);
const annualLeave = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 5C2 3.89543 2.89543 3 4 3H11C12.1046 3 13 3.89543 13 5V9C13 10.1046 12.1046 11 11 11H9L6 14V11H4C2.89543 11 2 10.1046 2 9V5ZM15 7V9C15 11.2091 13.2091 13 11 13H9.82843L8.06173 14.7667C8.34154 14.9156 8.66091 15 9 15H11L14 18V15H16C17.1046 15 18 14.1046 18 13V9C18 7.89543 17.1046 7 16 7H15Z"
      fill={className ? "currentColor" : "#4B5563"}
    />
    <path
      d="M2 5C2 3.89543 2.89543 3 4 3H11C12.1046 3 13 3.89543 13 5V9C13 10.1046 12.1046 11 11 11H9L6 14V11H4C2.89543 11 2 10.1046 2 9V5ZM15 7V9C15 11.2091 13.2091 13 11 13H9.82843L8.06173 14.7667C8.34154 14.9156 8.66091 15 9 15H11L14 18V15H16C17.1046 15 18 14.1046 18 13V9C18 7.89543 17.1046 7 16 7H15Z"
      stroke={className ? "currentColor" : "#4B5563"}
    />
  </svg>
);
const createInterview = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3C10.5523 3 11 3.44772 11 4V9H16C16.5523 9 17 9.44772 17 10C17 10.5523 16.5523 11 16 11H11V16C11 16.5523 10.5523 17 10 17C9.44772 17 9 16.5523 9 16V11H4C3.44772 11 3 10.5523 3 10C3 9.44771 3.44772 9 4 9L9 9V4C9 3.44772 9.44772 3 10 3Z"
      fill={className ? "currentColor" : "#4B5563"}
    />
  </svg>
);
const trainingResource = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 6C2 4.89543 2.89543 4 4 4H10C11.1046 4 12 4.89543 12 6V14C12 15.1046 11.1046 16 10 16H4C2.89543 16 2 15.1046 2 14V6ZM14.5528 7.10557C14.214 7.27497 14 7.62123 14 8V12C14 12.3788 14.214 12.725 14.5528 12.8944L16.5528 13.8944C16.8628 14.0494 17.2309 14.0329 17.5257 13.8507C17.8205 13.6684 18 13.3466 18 13V7C18 6.65342 17.8205 6.33156 17.5257 6.14935C17.2309 5.96714 16.8628 5.95058 16.5528 6.10557L14.5528 7.10557Z"
      fill={className ? "currentColor" : "#4B5563"}
    />
    <path
      d="M2 6C2 4.89543 2.89543 4 4 4H10C11.1046 4 12 4.89543 12 6V14C12 15.1046 11.1046 16 10 16H4C2.89543 16 2 15.1046 2 14V6ZM14.5528 7.10557C14.214 7.27497 14 7.62123 14 8V12C14 12.3788 14.214 12.725 14.5528 12.8944L16.5528 13.8944C16.8628 14.0494 17.2309 14.0329 17.5257 13.8507C17.8205 13.6684 18 13.3466 18 13V7C18 6.65342 17.8205 6.33156 17.5257 6.14935C17.2309 5.96714 16.8628 5.95058 16.5528 6.10557L14.5528 7.10557Z"
      stroke={className ? "currentColor" : "#4B5563"}
    />
  </svg>
);
const staffSurvey = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 2C8.44772 2 8 2.44772 8 3C8 3.55228 8.44772 4 9 4H11C11.5523 4 12 3.55228 12 3C12 2.44772 11.5523 2 11 2H9ZM4 5C4 3.89543 4.89543 3 6 3C6 4.65685 7.34315 6 9 6H11C12.6569 6 14 4.65685 14 3C15.1046 3 16 3.89543 16 5V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V5ZM7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H7.01C7.56228 11 8.01 10.5523 8.01 10C8.01 9.44772 7.56228 9 7.01 9H7ZM10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H10ZM7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H7.01C7.56228 15 8.01 14.5523 8.01 14C8.01 13.4477 7.56228 13 7.01 13H7ZM10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H10Z"
      fill={className ? "currentColor" : "#4B5563"}
    />
    <path
      d="M9 2C8.44772 2 8 2.44772 8 3C8 3.55228 8.44772 4 9 4H11C11.5523 4 12 3.55228 12 3C12 2.44772 11.5523 2 11 2H9ZM4 5C4 3.89543 4.89543 3 6 3C6 4.65685 7.34315 6 9 6H11C12.6569 6 14 4.65685 14 3C15.1046 3 16 3.89543 16 5V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V5ZM7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H7.01C7.56228 11 8.01 10.5523 8.01 10C8.01 9.44772 7.56228 9 7.01 9H7ZM10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H10ZM7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H7.01C7.56228 15 8.01 14.5523 8.01 14C8.01 13.4477 7.56228 13 7.01 13H7ZM10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H10Z"
      stroke={className ? "currentColor" : "#4B5563"}
    />
  </svg>
);
const contact = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 5V13C18 14.1046 17.1046 15 16 15H11L6 19V15H4C2.89543 15 2 14.1046 2 13V5C2 3.89543 2.89543 3 4 3H16C17.1046 3 18 3.89543 18 5ZM7 8H5V10H7V8ZM9 8H11V10H9V8ZM15 8H13V10H15V8Z"
      fill={className ? "currentColor" : "#4B5563"}
    />
    <path
      d="M18 5V13C18 14.1046 17.1046 15 16 15H11L6 19V15H4C2.89543 15 2 14.1046 2 13V5C2 3.89543 2.89543 3 4 3H16C17.1046 3 18 3.89543 18 5ZM7 8H5V10H7V8ZM9 8H11V10H9V8ZM15 8H13V10H15V8Z"
      stroke={className ? "currentColor" : "#4B5563"}
    />
  </svg>
);
const loader = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    className={classNames("animate-spin", className)}
  >
    <path
      d="M2 20C2 10.0589 10.0589 2 20 2C29.9411 2 38 10.0589 38 20C38 29.9411 29.9411 38 20 38C10.0589 38 2 29.9411 2 20Z"
      stroke="#E5E7EB"
      strokeWidth="4"
    />
    <path
      d="M20 1.9884C20 0.890239 20.8924 -0.0102414 21.9852 0.0987597C24.7148 0.37104 27.3667 1.20279 29.7724 2.55008C32.7581 4.22214 35.2648 6.6323 37.0528 9.55003C38.8408 12.4678 39.8502 15.7954 39.9846 19.2148C40.1189 22.6342 39.3737 26.0308 37.8201 29.0798C36.2666 32.1288 33.9567 34.7282 31.1114 36.6294C28.2661 38.5305 24.9806 39.6699 21.5692 39.9383C18.1577 40.2068 14.7345 39.5955 11.6268 38.1629C9.12276 37.0085 6.89113 35.352 5.06641 33.3037C4.33593 32.4837 4.53988 31.2324 5.42831 30.587C6.31675 29.9415 7.55194 30.1486 8.30243 30.9503C9.71301 32.4572 11.406 33.682 13.2917 34.5514C15.7815 35.6991 18.5241 36.1889 21.2572 35.9738C23.9903 35.7587 26.6225 34.8459 28.902 33.3228C31.1815 31.7997 33.0321 29.7171 34.2768 27.2744C35.5214 24.8316 36.1185 22.1104 36.0108 19.3709C35.9032 16.6315 35.0945 13.9655 33.662 11.6279C32.2296 9.29034 30.2213 7.35941 27.8293 6.01983C26.0175 5.00519 24.0315 4.35551 21.9833 4.10002C20.8936 3.96409 20 3.08657 20 1.9884Z"
      fill="#0FACD7"
    />
  </svg>
);
const orientation = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      d="M10 3.5C10 2.67157 10.6716 2 11.5 2C12.3284 2 13 2.67157 13 3.5V4C13 4.55228 13.4477 5 14 5H17C17.5523 5 18 5.44772 18 6V9C18 9.55228 17.5523 10 17 10H16.5C15.6716 10 15 10.6716 15 11.5C15 12.3284 15.6716 13 16.5 13H17C17.5523 13 18 13.4477 18 14V17C18 17.5523 17.5523 18 17 18H14C13.4477 18 13 17.5523 13 17V16.5C13 15.6716 12.3284 15 11.5 15C10.6716 15 10 15.6716 10 16.5V17C10 17.5523 9.55228 18 9 18H6C5.44772 18 5 17.5523 5 17V14C5 13.4477 4.55228 13 4 13H3.5C2.67157 13 2 12.3284 2 11.5C2 10.6716 2.67157 10 3.5 10H4C4.55228 10 5 9.55228 5 9V6C5 5.44772 5.44772 5 6 5H9C9.55228 5 10 4.55228 10 4V3.5Z"
      fill="#4B5563"
    />
    <path
      d="M10 3.5C10 2.67157 10.6716 2 11.5 2C12.3284 2 13 2.67157 13 3.5V4C13 4.55228 13.4477 5 14 5H17C17.5523 5 18 5.44772 18 6V9C18 9.55228 17.5523 10 17 10H16.5C15.6716 10 15 10.6716 15 11.5C15 12.3284 15.6716 13 16.5 13H17C17.5523 13 18 13.4477 18 14V17C18 17.5523 17.5523 18 17 18H14C13.4477 18 13 17.5523 13 17V16.5C13 15.6716 12.3284 15 11.5 15C10.6716 15 10 15.6716 10 16.5V17C10 17.5523 9.55228 18 9 18H6C5.44772 18 5 17.5523 5 17V14C5 13.4477 4.55228 13 4 13H3.5C2.67157 13 2 12.3284 2 11.5C2 10.6716 2.67157 10 3.5 10H4C4.55228 10 5 9.55228 5 9V6C5 5.44772 5.44772 5 6 5H9C9.55228 5 10 4.55228 10 4V3.5Z"
      stroke="#9CA3AF"
    />
  </svg>
);
const archive = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <path
      d="M5.6001 2.3999C5.15827 2.3999 4.8001 2.75807 4.8001 3.1999C4.8001 3.64173 5.15827 3.9999 5.6001 3.9999H10.4001C10.8419 3.9999 11.2001 3.64173 11.2001 3.1999C11.2001 2.75807 10.8419 2.3999 10.4001 2.3999H5.6001Z"
      fill="#DB2777"
    />
    <path
      d="M3.2001 5.5999C3.2001 5.15807 3.55827 4.7999 4.0001 4.7999H12.0001C12.4419 4.7999 12.8001 5.15807 12.8001 5.5999C12.8001 6.04173 12.4419 6.3999 12.0001 6.3999H4.0001C3.55827 6.3999 3.2001 6.04173 3.2001 5.5999Z"
      fill="#DB2777"
    />
    <path
      d="M1.6001 8.7999C1.6001 7.91625 2.31644 7.1999 3.2001 7.1999H12.8001C13.6838 7.1999 14.4001 7.91625 14.4001 8.7999V11.9999C14.4001 12.8836 13.6838 13.5999 12.8001 13.5999H3.2001C2.31644 13.5999 1.6001 12.8836 1.6001 11.9999V8.7999Z"
      fill="#DB2777"
    />
  </svg>
);
const print = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 4V7H4C2.89543 7 2 7.89543 2 9V12C2 13.1046 2.89543 14 4 14H5V16C5 17.1046 5.89543 18 7 18H13C14.1046 18 15 17.1046 15 16V14H16C17.1046 14 18 13.1046 18 12V9C18 7.89543 17.1046 7 16 7H15V4C15 2.89543 14.1046 2 13 2H7C5.89543 2 5 2.89543 5 4ZM13 4H7V7H13V4ZM13 12H7V16H13V12Z"
      fill="#4B5563"
    />
  </svg>
);
const greyDocument = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 4C4 2.89543 4.89543 2 6 2H10.5858C11.1162 2 11.6249 2.21071 12 2.58579L15.4142 6C15.7893 6.37507 16 6.88378 16 7.41421V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V4ZM6 10C6 9.44772 6.44772 9 7 9H13C13.5523 9 14 9.44772 14 10C14 10.5523 13.5523 11 13 11H7C6.44772 11 6 10.5523 6 10ZM7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H7Z"
      fill="#4B5563"
    />
  </svg>
);
const comments = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      d="M2 5C2 3.89543 2.89543 3 4 3H11C12.1046 3 13 3.89543 13 5V9C13 10.1046 12.1046 11 11 11H9L6 14V11H4C2.89543 11 2 10.1046 2 9V5Z"
      fill="#4B5563"
    />
    <path
      d="M15 7V9C15 11.2091 13.2091 13 11 13H9.82843L8.06173 14.7667C8.34154 14.9156 8.66091 15 9 15H11L14 18V15H16C17.1046 15 18 14.1046 18 13V9C18 7.89543 17.1046 7 16 7H15Z"
      fill="#4B5563"
    />
  </svg>
);
const redCross = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM8.70711 7.29289C8.31658 6.90237 7.68342 6.90237 7.29289 7.29289C6.90237 7.68342 6.90237 8.31658 7.29289 8.70711L8.58579 10L7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071C7.68342 13.0976 8.31658 13.0976 8.70711 12.7071L10 11.4142L11.2929 12.7071C11.6834 13.0976 12.3166 13.0976 12.7071 12.7071C13.0976 12.3166 13.0976 11.6834 12.7071 11.2929L11.4142 10L12.7071 8.70711C13.0976 8.31658 13.0976 7.68342 12.7071 7.29289C12.3166 6.90237 11.6834 6.90237 11.2929 7.29289L10 8.58579L8.70711 7.29289Z"
      fill="#EF4444"
    />
  </svg>
);
const clients = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 6V5C6 3.34315 7.34315 2 9 2H11C12.6569 2 14 3.34315 14 5V6H16C17.1046 6 18 6.89543 18 8V11.5708C15.5096 12.4947 12.8149 12.9999 10 12.9999C7.18514 12.9999 4.49037 12.4947 2 11.5707V8C2 6.89543 2.89543 6 4 6H6ZM8 5C8 4.44772 8.44772 4 9 4H11C11.5523 4 12 4.44772 12 5V6H8V5ZM9 10C9 9.44772 9.44772 9 10 9H10.01C10.5623 9 11.01 9.44772 11.01 10C11.01 10.5523 10.5623 11 10.01 11H10C9.44772 11 9 10.5523 9 10Z"
      fill={className ? "currentColor" : "#4B5563"}
    />
    <path
      d="M2 13.6923V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V13.6923C15.4872 14.5404 12.7964 14.9999 10 14.9999C7.20363 14.9999 4.51279 14.5404 2 13.6923Z"
      fill={className ? "currentColor" : "#4B5563"}
    />
  </svg>
);
const alliedHealthService = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.99985 2C6.59539 2 6.23075 2.24364 6.07597 2.61732C5.92119 2.99099 6.00675 3.42111 6.29275 3.70711L6.99985 4.41421V8.17157C6.99985 8.43679 6.8945 8.69114 6.70696 8.87868L2.70696 12.8787C0.817066 14.7686 2.15556 18 4.82828 18H15.1714C17.8441 18 19.1826 14.7686 17.2927 12.8787L13.2927 8.87868C13.1052 8.69114 12.9999 8.43679 12.9999 8.17157V4.41421L13.707 3.70711C13.993 3.42111 14.0785 2.99099 13.9237 2.61732C13.769 2.24364 13.4043 2 12.9999 2H6.99985ZM8.99985 8.17157V4H10.9999V8.17157C10.9999 8.96722 11.3159 9.73028 11.8785 10.2929L12.9061 11.3204C12.1892 11.1537 11.4377 11.1874 10.7349 11.4217L10.2647 11.5784C9.44364 11.8521 8.55596 11.8521 7.73489 11.5784L7.17244 11.3909C7.13436 11.3782 7.09607 11.3667 7.05762 11.3564L8.12117 10.2929C8.68378 9.73028 8.99985 8.96722 8.99985 8.17157Z"
      fill={className ? "currentColor" : "#4B5563"}
    />
  </svg>
);
const subContractor = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    className={className}
  >
    <path
      d="M8 3C8 2.44772 8.44772 2 9 2H11C11.5523 2 12 2.44772 12 3C12 3.55228 11.5523 4 11 4H9C8.44772 4 8 3.55228 8 3Z"
      fill={className ? "currentColor" : "#4B5563"}
    />
    <path
      d="M6 3C4.89543 3 4 3.89543 4 5V16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16V5C16 3.89543 15.1046 3 14 3C14 4.65685 12.6569 6 11 6H9C7.34315 6 6 4.65685 6 3Z"
      fill={className ? "currentColor" : "#4B5563"}
    />
  </svg>
);
const lock = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
      clipRule="evenodd"
    />
  </svg>
);
const solidEye = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="currentColor"
    width={size}
    height={size}
  >
    <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
    <path
      fillRule="evenodd"
      d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z"
      clipRule="evenodd"
    />
  </svg>
);
const xCircle = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="currentColor"
    width={size}
    height={size}
  >
    <path
      fillRule="evenodd"
      d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
      clipRule="evenodd"
    />
  </svg>
);
const documentExpired = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="currentColor"
    width={size}
    height={size}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2C4.89543 2 4 2.89543 4 4V16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16V7.41421C16 6.88378 15.7893 6.37507 15.4142 6L12 2.58579C11.6249 2.21071 11.1162 2 10.5858 2H6ZM10 15C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15ZM9 7C9 6.44772 9.44772 6 10 6C10.5523 6 11 6.44772 11 7V10C11 10.5523 10.5523 11 10 11C9.44772 11 9 10.5523 9 10V7Z"
    />
  </svg>
);
const solidArchive = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="currentColor"
    width={size}
    height={size}
  >
    <path d="M4 3a2 2 0 100 4h12a2 2 0 100-4H4z" />
    <path
      fillRule="evenodd"
      d="M3 8h14v7a2 2 0 01-2 2H5a2 2 0 01-2-2V8zm5 3a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1z"
      clipRule="evenodd"
    />
  </svg>
);
const support = (
  stroke: string,
  className: string,
  size = 20,
  height: number,
  width: number
) => (
  <svg
    className={classNames(className, "h-5 w-5")}
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-2 0c0 .993-.241 1.929-.668 2.754l-1.524-1.525a3.997 3.997 0 00.078-2.183l1.562-1.562C15.802 8.249 16 9.1 16 10zm-5.165 3.913l1.58 1.58A5.98 5.98 0 0110 16a5.976 5.976 0 01-2.516-.552l1.562-1.562a4.006 4.006 0 001.789.027zm-4.677-2.796a4.002 4.002 0 01-.041-2.08l-.08.08-1.53-1.533A5.98 5.98 0 004 10c0 .954.223 1.856.619 2.657l1.54-1.54zm1.088-6.45A5.974 5.974 0 0110 4c.954 0 1.856.223 2.657.619l-1.54 1.54a4.002 4.002 0 00-2.346.033L7.246 4.668zM12 10a2 2 0 11-4 0 2 2 0 014 0z"
      clipRule="evenodd"
    />
  </svg>
);

const presentationChartBar = (
  stroke: string,
  className: string,
  size = 20,
  height: number,
  width: number
) => (
  <svg
    className={classNames(className, "h-5 w-5")}
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M3 3a1 1 0 000 2v8a2 2 0 002 2h2.586l-1.293 1.293a1 1 0 101.414 1.414L10 15.414l2.293 2.293a1 1 0 001.414-1.414L12.414 15H15a2 2 0 002-2V5a1 1 0 100-2H3zm11 4a1 1 0 10-2 0v4a1 1 0 102 0V7zm-3 1a1 1 0 10-2 0v3a1 1 0 102 0V8zM8 9a1 1 0 00-2 0v2a1 1 0 102 0V9z"
      clipRule="evenodd"
    />
  </svg>
);

const clipboardList = (
  stroke: string,
  className: string,
  size = 20,
  height: number,
  width: number
) => (
  <svg
    className={classNames(className, "h-5 w-5")}
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
    <path
      fillRule="evenodd"
      d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
      clipRule="evenodd"
    />
  </svg>
);

const clipboardCheck = (
  stroke: string,
  className: string,
  size = 20,
  height: number,
  width: number
) => (
  <svg
    className={classNames(className, "h-5 w-5")}
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
    <path
      fillRule="evenodd"
      d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm9.707 5.707a1 1 0 00-1.414-1.414L9 12.586l-1.293-1.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
      clipRule="evenodd"
    />
  </svg>
);

const lockClosed = (
  stroke: string,
  className: string,
  size = 20,
  height: number,
  width: number
) => (
  <svg
    className={classNames(className, "h-5 w-5")}
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
      clipRule="evenodd"
    />
  </svg>
);

const genericPhone = (
  stroke: string,
  className: string,
  size = 20,
  height: number,
  width: number
) => (
  <svg
    className={classNames(className, "h-5 w-5")}
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
  </svg>
);
const solidMinus = (
  stroke: string,
  className: string,
  size = 20,
  height: number,
  width: number
) => (
  <svg
    className={classNames(className, "h-5 w-5")}
    viewBox="0 0 20 20"
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 000 2h6a1 1 0 100-2H7z"
      clipRule="evenodd"
    />
  </svg>
);

const solidPlus = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="currentColor"
    width={size}
    height={size}
  >
    <path
      fillRule="evenodd"
      d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
      clipRule="evenodd"
    />
  </svg>
);
const solidCalendar = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="currentColor"
    width={size}
    height={size}
  >
    <path
      fill-rule="evenodd"
      d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"
      clip-rule="evenodd"
    />
  </svg>
);
const trendingUp = (
  stroke: string,
  className: string,
  size = 16,
  height: number,
  width: number
) => (
  <svg
    className={className}
    viewBox="0 0 20 20"
    fill="currentColor"
    width={size}
    height={size}
  >
    <path
      fill-rule="evenodd"
      d="M12 7a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0V8.414l-4.293 4.293a1 1 0 01-1.414 0L8 10.414l-4.293 4.293a1 1 0 01-1.414-1.414l5-5a1 1 0 011.414 0L11 10.586 14.586 7H12z"
      clip-rule="evenodd"
    />
  </svg>
);

const mapping = {
  inviteUser,
  plus,
  check,
  error,
  warning,
  solidCheck,
  accordionOpen,
  accordionClose,
  step1,
  step2,
  step3,
  step4,
  step5,
  step6,
  step7,
  step8,
  step9,
  step10,
  upload,
  leftArrow,
  rightArrow,
  back,
  redDelete,
  document,
  exclamation,
  pencil,
  info,
  downChevron,
  calendar,
  disabledDelete,
  clock,
  search,
  logo,
  download,
  invited,
  inProgress,
  hazardWarning,
  recycle,
  assistance,
  email,
  phone,
  solidCross,
  coloredCheck,
  rightDirectionArrow,
  user,
  calendarOutline,
  comment,
  close,
  logout,
  filter,
  userGrayAndWhite,
  settings,
  bell,
  addNewStaff,
  groups,
  annualLeave,
  createInterview,
  trainingResource,
  staffSurvey,
  contact,
  loader,
  orientation,
  archive,
  print,
  greyDocument,
  comments,
  redCross,
  deleteIcon,
  clients,
  alliedHealthService,
  subContractor,
  lock,
  solidEye,
  xCircle,
  documentExpired,
  solidArchive,
  support,
  presentationChartBar,
  clipboardList,
  clipboardCheck,
  lockClosed,
  genericPhone,
  solidMinus,
  solidPlus,
  solidCalendar,
  trendingUp,
};

export type IconName = keyof typeof mapping;

export const icons = Object.keys(mapping).map(
  (iconName) => iconName as IconName
);

interface IconProps {
  name: IconName;
  stroke?: string;
  className?: string;
  size?: number;
  height?: number;
  width?: number;
}

export const Icon: React.FC<IconProps> = ({
  className = "",
  name,
  stroke = "none",
  size = 16,
  height = 16,
  width = 16,
}) => {
  return mapping[name](stroke, className, size, height, width);
};
